// 二级品牌馆配置 u联盟
export default {
  'test-x.ubanquan.cn': {
    // 主应用二级品牌馆id映射
    development: {
      storeNo: 'ST059001841000001686641424',
      storeName: '创新生态馆',
      microHost: 'test-y.ubanquan.cn'
    },
    test: {
      storeNo: 'ST059001841000001686641424',
      storeName: '创新生态馆',
      microHost: 'test-y.ubanquan.cn'
    },
    realpre: {
      storeNo: 'ST059001841000001686641424',
      storeName: '创新生态馆',
      microHost: 'test-y.ubanquan.cn'
    },
    production: {
      storeNo: 'ST059001841000001686641424',
      storeName: '创新生态馆',
      microHost: 'test-y.ubanquan.cn'
    }
  },
  'test-x-1.ubanquan.cn': {
    // 主应用二级品牌馆id映射
    development: {
      storeNo: 'ST059001212300001675330739',
      storeName: '创新生态馆',
      microHost: 'test-y-1.ubanquan.cn'
    },
    test: {
      storeNo: 'ST059001212300001675330739',
      storeName: '创新生态馆1',
      microHost: 'test-y-1.ubanquan.cn'
    },
    realpre: {
      storeNo: 'ST059001212300001675330739',
      storeName: '创新生态馆',
      microHost: 'test-y-1.ubanquan.cn'
    },
    production: {
      storeNo: 'ST059001212300001675330739',
      storeName: '创新生态馆',
      microHost: 'test-y-1.ubanquan.cn'
    }
  }
};